<div class="mb-2">
  <button mat-raised-button class="main-font" routerLink="storico-team-passati">
    Storico
  </button>
</div>
<mat-tab-group
  *ngIf="
    teamsProjects?.length > 0 || teamsCourses?.length > 0;
    else noTeamBlock
  ">
  <mat-tab label="Progetti" *ngIf="teamsProjects?.length > 0">
    <nz-row class="mt-4">
      <nz-col
        [nzLg]="{ span: 6, offset: 18 }"
        [nzMd]="{ span: 10, offset: 14 }"
        [nzSm]="{ span: 24, offset: 0 }"
        class="w-100">
        <nz-select
          class="w-100"
          nzMode="multiple"
          [nzServerSearch]="true"
          nzPlaceHolder="Seleziona un team"
          [nzMaxTagCount]="2"
          (nzOnSearch)="onSearchTeam($event)"
          [nzAllowClear]="true"
          [(ngModel)]="selectedTeamProjects"
          (ngModelChange)="onSelectTamsProject($event)">
          <nz-option
            *ngFor="let team of teamProjectsSelect"
            [nzValue]="team.id"
            [nzLabel]="team.alias"></nz-option>
        </nz-select>
      </nz-col>
    </nz-row>
    <div class="row py-4">
      <!-- projects-wrapper -->
      <!-- NUOVE CARD -->
      <div
        *ngFor="let project of teamsProjects; let j = index"
        class="col-xl-6 col-lg-12 col-md-12"
        #card>
        <!-- project-container -->
        <mat-card class="project-card" style="margin-bottom: 25px">
          <mat-card-header
            class="main-font justify-content-between primary-color-light">
            <div
              class="d-flex justify-content-between align-items-center w-100">
              <div class="d-flex align-items-center">
                <label class="image-container col-1 me-2">
                  <img
                    [src]="
                      utilityService.getSanitizeUrl(project.filestorage.path)
                    "
                    alt="project image"
                    class="logo imageLogo mt-3 rounded-circle" />
                </label>
                <h3 class="title">{{ project?.alias }}</h3>
              </div>
              <div class="d-flex justify-content-end w-100">
                <mat-card-actions
                  class="d-flex align-items-center mt-2 mt-md-0">
                  <!-- Bottone Statistiche con MatIcon solo in modalità mobile -->
                  <button
                    mat-raised-button
                    color="accent"
                    class="me-2"
                    (click)="toggleFlip(card, project.id, j)"
                    [disabled]="!project?.is_statistical"
                    *ngIf="isMobile">
                    <div
                      class="d-flex justify-content-center align-items-center">
                      <mat-icon
                        aria-hidden="false"
                        aria-label="Statistiche"
                        style="color: white"
                        >bar_chart</mat-icon
                      >
                    </div>
                  </button>
                  <!-- Bottone Scrum con MatIcon solo in modalità mobile -->
                  <button
                    mat-raised-button
                    color="accent"
                    routerLink="bacheca"
                    (click)="goToScrum(project)"
                    *ngIf="isMobile">
                    <!--<mat-icon aria-hidden="false" aria-label="Scrum" style="color: white;">list_alt</mat-icon>-->
                    <div
                      class="d-flex justify-content-center align-items-center">
                      <img
                        style="height: 18px"
                        src="assets/images/icona-sprint.svg"
                        alt="icona sprint" />
                    </div>
                  </button>
                  <!-- Bottone Statistiche con testo solo in modalità desktop -->
                  <button
                    mat-raised-button
                    class="me-2 statistical-btn"
                    (click)="toggleFlip(card, project.id, j)"
                    [disabled]="!project?.is_statistical"
                    *ngIf="!isMobile && project.is_teamleading != 1">
                    Statistiche
                  </button>
                  <!-- Bottone Scrum con testo solo in modalità desktop -->
                  <button
                    mat-raised-button
                    color="accent"
                    routerLink="bacheca"
                    (click)="goToScrum(project)"
                    *ngIf="!isMobile && project.is_teamleading != 1">
                    Scrum
                  </button>
                </mat-card-actions>
              </div>
            </div>
          </mat-card-header>

          <mat-card-content class="scroll scrollbar pt-3 card-inner">
            <!-- Card -->
            <div class="front-face col-12">
              <div
                *ngIf="teamsProjects[j]?.project_user.length != 0; else sadGif">
                <app-card-membro-team
                  (getProfile)="getElement($event)"
                  [data]="project?.project_user">
                </app-card-membro-team>
              </div>
            </div>

            <!-- Card -->
            <div class="back-face col-12 align-items-center">
              <div class="row g-4" *ngIf="project?.statistical?.Numbers">
                <div class="col-6 dropdown">
                  <button
                    class="scrum-btn w-100 dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown">
                    Da sprint {{ project?.statistical?.start_sprint_number }}
                  </button>
                  <ul class="dropdown-menu sprint-list">
                    <li
                      *ngFor="
                        let sprint of project?.statistical?.Numbers;
                        index as i
                      "
                      ngClass="{{
                        project?.statistical?.start_sprint_number == sprint
                          ? 'selected-li'
                          : project?.statistical?.end_sprint_number
                            ? project?.statistical?.end_sprint_number >= sprint
                              ? 'pointer'
                              : 'no-pointer'
                            : 'pointer'
                      }}">
                      <a
                        class="dropdown-item"
                        ngClass="{{
                          project?.statistical?.end_sprint_number
                            ? project?.statistical?.end_sprint_number >= sprint
                              ? ''
                              : 'no-pointer'
                            : ''
                        }}"
                        (click)="
                          setDate(
                            project.id,
                            sprint,
                            true,
                            project?.statistical?.end_sprint_number,
                            j
                          )
                        ">
                        {{ sprint }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-6 dropdown">
                  <button
                    class="scrum-btn w-100 dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown">
                    A sprint {{ project?.statistical?.end_sprint_number }}
                  </button>
                  <ul class="dropdown-menu sprint-list">
                    <li
                      *ngFor="
                        let sprint of project?.statistical?.Numbers;
                        index as i
                      "
                      ngClass="{{
                        project?.statistical?.end_sprint_number == sprint
                          ? 'selected-li'
                          : project?.statistical?.start_sprint_number
                            ? project?.statistical?.start_sprint_number <=
                              sprint
                              ? 'pointer'
                              : 'no-pointer'
                            : 'pointer'
                      }}">
                      <a
                        class="dropdown-item"
                        ngClass="{{
                          project?.statistical?.start_sprint_number
                            ? project?.statistical?.start_sprint_number <=
                              sprint
                              ? ''
                              : 'no-pointer'
                            : ''
                        }}"
                        (click)="
                          setDate(
                            project.id,
                            sprint,
                            false,
                            project?.statistical?.start_sprint_number,
                            j
                          )
                        ">
                        {{ sprint }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div [id]="'graphCarousel' + project.id" class="carousel slide">
                <div class="carousel-indicators fixed">
                  <button
                    type="button"
                    [attr.data-bs-target]="'#graphCarousel' + project.id"
                    data-bs-slide-to="0"
                    class="indicator active"
                    aria-current="true"
                    aria-label="Contatori"></button>
                  <button
                    type="button"
                    [attr.data-bs-target]="'#graphCarousel' + project.id"
                    data-bs-slide-to="1"
                    class="indicator"
                    aria-label="Velocity"></button>
                  <button
                    type="button"
                    [attr.data-bs-target]="'#graphCarousel' + project.id"
                    data-bs-slide-to="2"
                    class="indicator"
                    aria-label="Capacity"></button>
                  <button
                    type="button"
                    [attr.data-bs-target]="'#graphCarousel' + project.id"
                    data-bs-slide-to="3"
                    class="indicator"
                    aria-label="TeamAssessment"></button>
                </div>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div
                      class="row row-cols-lg-3 row-cols-md-2 row-cols-1 g-4 mt-1"
                      style="margin-bottom: 35px">
                      <div class="col-6">
                        <mat-card class="count-card">
                          <mat-card-title-group
                            class="h5 justify-content-center text-center mt-4">
                            <mat-card-title class="lh-lg"
                              >SP {{ !isMobile ? 'FATTI' : '' }}</mat-card-title
                            >
                            <mat-card-title class="lh-1" *ngIf="isMobile"
                              >FATTI</mat-card-title
                            >
                          </mat-card-title-group>
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Sp_done }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-6">
                        <mat-card class="count-card">
                          <mat-card-title-group
                            class="h5 justify-content-center text-center mt-4">
                            <mat-card-title class="lh-lg"
                              >CAPACITY
                              {{ !isMobile ? 'TOT' : '' }}</mat-card-title
                            >
                            <mat-card-title class="lh-1" *ngIf="isMobile"
                              >TOT</mat-card-title
                            >
                          </mat-card-title-group>
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Capacity_tot }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-6">
                        <mat-card class="count-card">
                          <mat-card-title-group
                            class="h5 justify-content-center text-center mt-4">
                            <mat-card-title class="lh-lg"
                              >VELOCITY
                              {{ !isMobile ? 'MEDIA' : '' }}</mat-card-title
                            >
                            <mat-card-title class="lh-1" *ngIf="isMobile"
                              >MEDIA</mat-card-title
                            >
                          </mat-card-title-group>
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Velocity_team }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-6">
                        <mat-card class="count-card">
                          <mat-card-title-group
                            class="h5 justify-content-center text-center mt-4">
                            <mat-card-title class="lh-lg"
                              >SP
                              {{
                                !isMobile ? 'SENZA RESIDUO' : ''
                              }}</mat-card-title
                            >
                            <mat-card-title class="lh-1" *ngIf="isMobile"
                              >SENZA RESIDUO</mat-card-title
                            >
                          </mat-card-title-group>
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Sp_without_residues }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-6">
                        <mat-card class="count-card">
                          <mat-card-title-group
                            class="h5 justify-content-center text-center mt-4">
                            <mat-card-title class="lh-lg"
                              >% SP
                              {{
                                !isMobile ? 'SVILUPPATORE' : ''
                              }}</mat-card-title
                            >
                            <mat-card-title class="lh-1" *ngIf="isMobile"
                              >SVILUPPATORE</mat-card-title
                            >
                          </mat-card-title-group>
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Sp_sviluppatore }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-6">
                        <mat-card class="count-card">
                          <mat-card-title-group
                            class="h5 justify-content-center text-center mt-4">
                            <mat-card-title class="lh-lg"
                              >VELOCITY
                              {{ !isMobile ? 'CLIENTE' : '' }}</mat-card-title
                            >
                            <mat-card-title class="lh-1" *ngIf="isMobile"
                              >CLIENTE</mat-card-title
                            >
                          </mat-card-title-group>
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Velocity_cliente }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="mt-4">
                      <canvas
                        class="chart"
                        [hidden]="!card.classList.contains('flipped')"
                        [id]="'evolChart' + j"
                        #evolChart></canvas>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="mt-4">
                      <canvas
                        class="chart"
                        [hidden]="!card.classList.contains('flipped')"
                        [id]="'capChart' + j"
                        #capChart></canvas>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <h6 class="w-100 text-center mt-3">Team Assessment</h6>
                    <div class="mt-4">
                      <canvas
                        class="chart"
                        [hidden]="!card.classList.contains('flipped')"
                        [id]="'teamChart' + j"
                        #teamChart></canvas>
                    </div>

                    <div class="d-flex justify-content-center mt-2">
                      <p>Medie</p>
                    </div>

                    <div
                      class="d-flex justify-content-lg-between justify-content-center mb-4 flex-wrap">
                      <div
                        *ngFor="let data of media; let i = index"
                        class="d-flex align-items-center mt-sm-3">
                        <ng-container [ngSwitch]="data.alias">
                          <img
                            *ngSwitchCase="'Work-life Balance'"
                            src="assets/images/balanced.svg"
                            alt="Work-life Balance"
                            class="me-1 assessment-icon"
                            [nz-tooltip]="data.alias" />
                          <img
                            *ngSwitchCase="'Clarity'"
                            src="assets/images/search.svg"
                            alt="Clarity"
                            class="me-1 assessment-icon"
                            [nz-tooltip]="data.alias" />
                          <img
                            *ngSwitchCase="'Efficiency'"
                            src="assets/images/manufacturing.svg"
                            alt="Efficiency"
                            class="me-1 assessment-icon"
                            [nz-tooltip]="data.alias" />
                          <img
                            *ngSwitchCase="'Psychological Safety'"
                            src="assets/images/handshake_asse.svg"
                            alt="Psychological Safety"
                            class="me-1 assessment-icon"
                            [nz-tooltip]="data.alias" />
                          <img
                            *ngSwitchCase="'Energy'"
                            src="assets/images/bolt.svg"
                            alt="Energy"
                            class="me-1 assessment-icon"
                            [nz-tooltip]="data.alias" />
                          <img
                            *ngSwitchCase="'Confidence'"
                            src="assets/images/insert_chart.svg"
                            alt="Confidence"
                            class="me-1 assessment-icon"
                            [nz-tooltip]="data.alias" />
                        </ng-container>
                        <div [id]="'border' + i">
                          <p
                            class="d-flex align-items-center justify-content-center mb-0 p-2">
                            {{ data.media }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Corsi" *ngIf="teamsCourses?.length > 0">
    <div class="row py-4">
      <!-- NUOVE CARD -->
      <div
        *ngFor="let project of teamsCourses; let j = index"
        class="col-lg-6 col-md-12"
        #card>
        <mat-card class="project-card" style="margin-bottom: 25px">
          <mat-card-header
            class="main-font justify-content-between primary-color-light">
            <mat-card-title-group
              class="d-flex align-items-center justify-content-start">
              <label class="image-container col-1 me-2">
                <img
                  [src]="project.filestorage.path"
                  alt="project image"
                  class="logo imageLogo mt-3 rounded-circle" />
              </label>
              <h3>{{ project?.alias }}</h3>
            </mat-card-title-group>
            <mat-card-actions class="justify-content-end">
              <button
                mat-raised-button
                color="accent"
                class="me-2"
                (click)="toggleFlip(card, project.id, j)"
                [disabled]="!project?.is_statistical">
                {{
                  card.classList.contains('flipped') ? 'Team' : 'Statistiche'
                }}
              </button>
            </mat-card-actions>
          </mat-card-header>

          <mat-card-content class="scroll scrollbar pt-3 card-inner">
            <div class="front-face col-12">
              <div
                *ngIf="teamsProjects[j]?.project_user.length != 0; else sadGif">
                <app-card-membro-team
                  (getProfile)="getElement($event)"
                  [data]="project?.project_user">
                </app-card-membro-team>
              </div>
            </div>
            <div class="back-face col-12 align-items-center">
              <div class="row g-4" *ngIf="project?.statistical?.Numbers">
                <div class="col-4 dropdown">
                  <button
                    class="scrum-btn w-100 dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown">
                    Da sprint {{ project?.statistical?.start_sprint_number }}
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      *ngFor="
                        let sprint of project?.statistical?.Numbers;
                        index as i
                      "
                      ngClass="{{
                        project?.statistical?.start_sprint_number == sprint
                          ? 'selected-li'
                          : project?.statistical?.end_sprint_number
                            ? project?.statistical?.end_sprint_number >= sprint
                              ? 'pointer'
                              : 'no-pointer'
                            : 'pointer'
                      }}">
                      <a
                        class="dropdown-item"
                        ngClass="{{
                          project?.statistical?.end_sprint_number
                            ? project?.statistical?.end_sprint_number >= sprint
                              ? ''
                              : 'no-pointer'
                            : ''
                        }}"
                        (click)="
                          setDate(
                            project.id,
                            sprint,
                            true,
                            project?.statistical?.end_sprint_number,
                            j
                          )
                        ">
                        {{ sprint }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-4 dropdown">
                  <button
                    class="scrum-btn w-100 dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown">
                    A sprint
                    {{
                      project?.statistical?.end_sprint_number
                        ? project?.statistical?.end_sprint_number
                        : ''
                    }}
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      *ngFor="
                        let sprint of project?.statistical?.Numbers;
                        index as i
                      "
                      ngClass="{{
                        project?.statistical?.end_sprint_number == sprint
                          ? 'selected-li'
                          : project?.statistical?.start_sprint_number
                            ? project?.statistical?.start_sprint_number <=
                              sprint
                              ? 'pointer'
                              : 'no-pointer'
                            : 'pointer'
                      }}">
                      <a
                        class="dropdown-item"
                        ngClass="{{
                          project?.statistical?.start_sprint_number
                            ? project?.statistical?.start_sprint_number <=
                              sprint
                              ? ''
                              : 'no-pointer'
                            : ''
                        }}"
                        (click)="
                          setDate(
                            project.id,
                            sprint,
                            false,
                            project?.statistical?.start_sprint_number,
                            j
                          )
                        ">
                        {{ sprint }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div [id]="'graphCarousel' + project.id" class="carousel slide">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="row g-4 mt-1">
                      <div class="col-4">
                        <mat-card class="count-card">
                          <mat-card-title class="h5 text-center"
                            >SP FATTI</mat-card-title
                          >
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Sp_done }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-4">
                        <mat-card class="count-card">
                          <mat-card-title class="h5 text-center"
                            >CAPACITY TOT</mat-card-title
                          >
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Capacity_tot }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-4">
                        <mat-card class="count-card">
                          <mat-card-title class="h5 text-center"
                            >VELOCITY MEDIA</mat-card-title
                          >
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Velocity_team }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-4">
                        <mat-card class="count-card">
                          <mat-card-title class="h5 text-center"
                            >SP SENZA RESIDUO</mat-card-title
                          >
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Sp_without_residues }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-4">
                        <mat-card class="count-card">
                          <mat-card-title class="h5 text-center"
                            >% SP SVILUPPATORE</mat-card-title
                          >
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Sp_sviluppatore }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div class="col-4">
                        <mat-card class="count-card">
                          <mat-card-title class="h5 text-center"
                            >VELOCITY CLIENTE</mat-card-title
                          >
                          <mat-card-content class="h1 text-center">
                            {{ project?.statistical?.Velocity_cliente }}
                          </mat-card-content>
                        </mat-card>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <svg
                      class="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
                      width="800"
                      height="400"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder: First slide"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false">
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#777"></rect>
                      <text x="50%" y="50%" fill="#555" dy=".3em">
                        Velocity
                      </text>
                    </svg>
                  </div>
                  <div class="carousel-item">
                    <svg
                      class="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
                      width="800"
                      height="400"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder: First slide"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false">
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#777"></rect>
                      <text x="50%" y="50%" fill="#555" dy=".3em">
                        Capacity
                      </text>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
<ng-template #noTeamBlock>
  <p class="text-center p-3">Non fai parte di nessun team</p>
</ng-template>
<!-- Tutta questa parte di codice potrebbe essere eliminata, ma per sicurezza e prendete spunto per adesso non l'ho tolta -->
<!-- Modale -->
<div
  class="modal fade"
  [id]="'showMore'"
  tabindex="-1"
  aria-labelledby="showMoreLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div>
          <p class="title-menu">Le mie aspirazioni</p>
          <p class="text-menu">{{ aspiration }}</p>
        </div>
        <div class="row mt-4 justify-content:start">
          <p class="title-menu mt-3">Hobby e passioni</p>
          <div
            class="row col-6 align-items-center p-3 justify-content-between"
            *ngFor="let parent of selected_user_profile?.hobbies">
            <div class="col-4">
              <button
                mat-fab
                color="white"
                data-toggle="tooltip"
                data-placement="bottom"
                [attr.title]="parent.children.length != 0 ? parent.alias : ''">
                <img
                  [src]="utilityService.getSanitizeUrl(parent.filestorage.path)"
                  class="parent-img" />
              </button>
            </div>
            <div
              *ngIf="parent.children.length == 0"
              class="col-8 justify-content-start">
              {{ parent.alias }}
            </div>
            <div
              class="row col-9"
              [ngClass]="{ 'justify-content-end': parent.children.length == 3 }"
              *ngIf="parent.children">
              <div class="col-4" *ngFor="let child of parent.children">
                <button
                  mat-mini-fab
                  color="white"
                  [matTooltip]="child?.alias"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  [attr.title]="child?.alias">
                  <img
                    [src]="
                      utilityService.getSanitizeUrl(child.filestorage.path)
                    "
                    class="icon-btn sm my-auto" />
                </button>
              </div>
            </div>
          </div>
          <!-- Mostra la scritta nessun hobby se hobbies è vuoto -->
          <p
            class="text-menu"
            *ngIf="selected_user_profile?.hobbies.length == 0">
            Nessun Hobby
          </p>
        </div>
        <div class="row mt-4 justify-content:start">
          <p class="title-menu mt-3">Cosa ci unisce</p>
          <div
            class="row col-6 align-items-center p-3 justify-content-between"
            *ngFor="let union of selected_user_profile?.hobbyunion">
            <div class="col-4">
              <button
                mat-fab
                color="white"
                data-toggle="tooltip"
                data-placement="bottom"
                [attr.title]="union.children.length != 0 ? union.alias : ''">
                <!-- <mat-icon class="icon-btn bg">{{union.img_path}}</mat-icon> -->
                <img
                  [src]="utilityService.getSanitizeUrl(union.filestorage.path)"
                  class="parent-img" />
              </button>
            </div>
            <div
              *ngIf="union.children.length == 0"
              class="col-8 justify-content-start">
              {{ union.alias }}
            </div>
            <div
              class="row col-9"
              [ngClass]="{ 'justify-content-end': union.children.length == 3 }"
              *ngIf="union.children">
              <div class="col-4" *ngFor="let child of union?.children">
                <button
                  mat-mini-fab
                  color="white"
                  [matTooltip]="child?.alias"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  [attr.title]="child?.alias">
                  <img
                    [src]="
                      utilityService.getSanitizeUrl(child.filestorage.path)
                    "
                    class="icon-btn sm my-auto" />
                </button>
              </div>
            </div>
          </div>
          <!-- avviso se non ci sono hobby in comune con un utente -->
          <div
            class="text-menu"
            *ngIf="selected_user_profile?.hobbyunion.length == 0">
            Nessun hobby in comune
          </div>
        </div>
        <div
          class="mt-4 text-end"
          *ngIf="
            selectedProjectRole == 'Project Manager' ||
            selectedProjectRole == 'Team Leader'
          ">
          <button
            mat-raised-button
            class="btn btn-primary"
            data-bs-dismiss="modal"
            routerLink="/secure/dashboard/percorso-di-crescita">
            Percorso di crescita
          </button>
        </div>
      </div>
      <!-- implementazione di button di chiusura della modal nel footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Gif in caso di team vuoto -->
<ng-template #sadGif>
  <div class="col-10 mx-auto">
    <ng-lottie [options]="lottieConfig" (animCreated)="handleAnimation($event)">
    </ng-lottie>
  </div>
</ng-template>
